export var DateRangePeriod;
(function (DateRangePeriod) {
    DateRangePeriod[DateRangePeriod["Last24Hours"] = 24] = "Last24Hours";
    DateRangePeriod[DateRangePeriod["Last48Hours"] = 48] = "Last48Hours";
    DateRangePeriod[DateRangePeriod["LastWeek"] = 168] = "LastWeek";
    DateRangePeriod[DateRangePeriod["LastMonth"] = 730] = "LastMonth";
    DateRangePeriod[DateRangePeriod["Last3Months"] = 2190] = "Last3Months";
    DateRangePeriod[DateRangePeriod["Last6Months"] = 4380] = "Last6Months";
    DateRangePeriod[DateRangePeriod["Last12Months"] = 8760] = "Last12Months";
})(DateRangePeriod || (DateRangePeriod = {}));
//# sourceMappingURL=DateRangePeriod.js.map